import { MessageCircle, Phone } from "lucide-react";
import { useContent } from "../lib/content";
import { useQuote } from "./QuoteModal";

export const FloatingButtons = () => {
  const { openQuote } = useQuote();
  const { SITE } = useContent();
  return (
    <>
      <a
        href={SITE.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-[4.5rem] right-5 z-[80] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 transition-transform hover:scale-110 sm:bottom-6"
        data-testid="floating-whatsapp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <MessageCircle className="relative h-6 w-6" />
      </a>

      {/* Mobile sticky action bar */}
      <div className="fixed bottom-0 left-0 right-0 z-[70] grid grid-cols-3 border-t border-slate-200 bg-white/95 backdrop-blur-md sm:hidden" data-testid="mobile-action-bar">
        <a href={SITE.phone1} className="flex items-center justify-center gap-1.5 py-3.5 text-xs font-bold text-brand-blue" data-testid="actionbar-call">
          <Phone className="h-4 w-4" /> Call Now
        </a>
        <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-1.5 bg-[#25D366] py-3.5 text-xs font-bold text-white" data-testid="actionbar-whatsapp">
          <MessageCircle className="h-4 w-4" /> WhatsApp
        </a>
        <button onClick={() => openQuote()} className="flex items-center justify-center gap-1.5 bg-brand-orange py-3.5 text-xs font-bold text-white" data-testid="actionbar-quote">
          Free Quote
        </button>
      </div>
      <div className="h-12 sm:hidden" />
    </>
  );
};
